import React from "react";

import MuiTab from "@material-ui/core/Tab";
import MuiTabs from "@material-ui/core/Tabs";

import { TabsBar } from "shared/ui/Tabs/styles";

export interface TabItem<T extends string = string> {
    key: T;
    label: React.ReactNode;
}

interface TabsProps<T extends string> {
    value: T;
    tabs: TabItem<T>[];
    onChange: (value: T) => void;
    className?: string;
}

// Переключатель табов: граница-подложка + MUI Tabs. Фичи не ходят в MUI напрямую.
export function Tabs<T extends string>({ value, tabs, onChange, className }: TabsProps<T>) {
    return (
        <TabsBar className={className}>
            <MuiTabs
                value={value}
                onChange={(_event, next) => onChange(next as T)}
                textColor="primary"
                indicatorColor="primary"
                variant="scrollable"
                scrollButtons="auto"
            >
                {tabs.map((tab) => (
                    <MuiTab key={tab.key} value={tab.key} label={tab.label} />
                ))}
            </MuiTabs>
        </TabsBar>
    );
}
